'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.pageCount = 10;
    this.jdUserPin;
    this.mac;
    this.orderId;
    this.novelBookId;
  }

  $onInit() {
    this.page = this.$stateParams.page || 1;
    this.getApps();
  }

  getApps() {
    var params = {
      where: {
        offset: (this.page - 1) * this.pageCount,
        limit: this.pageCount,
        sortBy: 'createdAt',
        sortOrder: false,
        jdUserPin: this.jdUserPin,
        mac: this.mac,
        orderId: this.orderId,
        novelBookId: this.novelBookId
      }
    };
    this.$http.get('/api/jdOrders', {params: params}).then(response => {
      this.jdOrder = response.data;
    });
  }

  pageChanged() {
    console.log(this.page)
    this.$state.go('jdOrder.list', {page: this.page});
  }

}



// WEBPACK FOOTER //
// ./client/app/jdOrder/list/list.controller.js